var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn12(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e23038;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.43,29.38h-18L36.88,18.15v-3h6.54a1.88,1.88,0,0,0,1.88-1.88V7.38A1.88,1.88,0,0,0,43.42,5.5H35a1.88,1.88,0,0,0-1.88,1.88V18.15L23.61,29.38h-18a1.88,1.88,0,0,0-1.88,1.88V62.62A1.88,1.88,0,0,0,5.57,64.5H64.43a1.88,1.88,0,0,0,1.88-1.88V31.26A1.88,1.88,0,0,0,64.43,29.38ZM36.88,9.26h4.66v2.15H36.88ZM22.6,60.74H7.44V33.13H22.6Zm14.86,0H32.54V48.26h4.92Zm6.19,0H41.21V46.39a1.88,1.88,0,0,0-1.87-1.88H30.66a1.88,1.88,0,0,0-1.87,1.88V60.74H26.35V32L35,21.74,43.65,32Zm18.91,0H47.4V33.13H62.56ZM28.83,35.52A6.17,6.17,0,1,0,35,29.35,6.18,6.18,0,0,0,28.83,35.52Zm8.59,0A2.42,2.42,0,1,1,35,33.1,2.42,2.42,0,0,1,37.42,35.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 70,
    height: 70
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn12);
export default __webpack_public_path__ + "static/media/icn_12.fed4eec7ca74107afe7552cb4bb4cd36.svg";
export { ForwardRef as ReactComponent };